export { TabRegistry } from "./registry"
export type { PeerInfo } from "./registry"
export type {
  TabMessage,
  AnnounceMsg,
  DepartMsg,
  RollCallMsg,
  FocusMsg,
} from "./protocol"

// Singleton for use across the app. Each page has exactly one registry.
import { TabRegistry } from "./registry"
export const tabRegistry = new TabRegistry()
